import accounting from 'accounting'

export default (amount) => accounting.formatMoney(amount, '$', 5, ' ', '.').replace(/\.?0+$/, '')
